import { render, staticRenderFns } from "./CardProductUser.vue?vue&type=template&id=82aaa412&"
import script from "./CardProductUser.vue?vue&type=script&lang=js&"
export * from "./CardProductUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports